import React from "react";
import Pane from "./subComponents/Pane.js";
import {
    MapContainer,
    TileLayer,
    useMap,
    Marker,
    Popup,
    useMapEvents,
} from "react-leaflet";

export default function Panel(params) {
    let logsArray = params.stateData.mapPoints.map((ele, index) => {
        return (
            <Pane
                index={index}
                coords={
                    `${ele.latitude}`.substring(0, 5) +
                    "-" +
                    `${ele.longitude}`.substring(0, 5) +
                    " :"
                }
                note={ele.note}
                changeStateData={params.changeStateData}
                stateData={params.stateData}
            />
        );
    });
    let [formDisplay, setFormDisplay] = React.useState("none");
    let [positionButton, setPositionButton] = React.useState("block");
    let collectFormData = function (event) {
        event.preventDefault();
        setFormDisplay("none");
        setPositionButton("block");
        navigator.geolocation.getCurrentPosition((pos) => {
            params.changeStateData((ele) => {
                let returnData = {
                    ...ele,
                    mapPoints: [
                        ...ele.mapPoints,
                        {
                            index: ele.mapPoints.length - 1,
                            latitude: pos.coords.latitude,
                            longitude: pos.coords.longitude,
                            note: document.querySelector(".text-input").value,
                        },
                    ],
                };
                localStorage.setItem("stateData", JSON.stringify(returnData));
                return returnData;
            });
        });
    };

    return (
        <section className="panel">
            <div
                className="panel-get-position"
                onClick={() => {
                    setFormDisplay("flex");
                    setPositionButton("none");
                    document.querySelector(".text-input").value = "";
                }}
                style={{ display: positionButton }}
            >
                GET POSITION
            </div>
            <div className="form-div" style={{ display: formDisplay }}>
                <form className="position-form" onSubmit={collectFormData}>
                    <input
                        type="text"
                        placeholder="Why am I here ?"
                        className="text-input"
                    />
                    <button type="submit" className="submitButton">
                        Lets Go !
                    </button>
                </form>
            </div>
            <div className="logs">
                <div className="logs-header">Past-Logs :</div>
                <div
                    className="logs-body"
                    key={"logs-body" + params.stateData.mapPoints.length}
                >
                    {logsArray}
                </div>
            </div>
        </section>
    );
}

// function LocationMarker() {
//     const [position, setPosition] = useState(null);
//     const map = useMapEvents({
//         click() {
//             map.locate();
//         },
//         locationfound(e) {
//             setPosition(e.latlng);
//             map.flyTo(e.latlng, map.getZoom());
//         },
//     });

//     return position === null ? null : (
//         <Marker position={position}>
//             <Popup>You are here</Popup>
//         </Marker>
//     );
// }
